export { DetailsType } from '@eneco/flows/types';

export enum EnergyType {
  Gas = 'gas',
  Electricity = 'electricity',
  ElectricityAndGas = 'electricityAndGas',
  ElectricityAndGasAndWarmth = 'electricityAndGasAndWarmth',
  ElectricityAndGasAndWarmthAndTapWater = 'electricityAndGasAndWarmthAndTapWater',
  ElectricityAndWarmth = 'electricityAndWarmth',
  ElectricityAndWarmthAndTapWater = 'electricityAndWarmthAndTapWater',
  Warmth = 'warmth',
  WarmthAndTapWater = 'warmthAndTapWater',
  TapWater = 'tapwater',
  ElectricityAndGeothermalHeating = 'electricityAndGeothermalHeating',
  GeothermalHeating = 'geothermalHeating',
}

export enum BuildingType {
  Apartment = 'apartment',
  TerracedHouse = 'terracedHouse',
  CornerHouse = 'cornerHouse',
  SemiDetachedHouse = 'semiDetachedHouse',
  DetachedHouse = 'detachedHouse',
}

export enum BuildingAgeType {
  Before1945 = 'before1945',
  Between1945And2000 = 'between1945And2000',
  After2000 = 'after2000',
  Unknown = 'unknown',
}
